import Coach from '@/views/whiteList/Index'
import CoachList from '@/views/whiteList/List'
import CoachEdit from '@/views/whiteList/Edit'

export default {
  name: '白名单',
  path: 'whiteList',
  component: Coach,
  redirect: 'whiteList/list',
  children: [{
    name: '白名单管理',
    path: 'list',
    component: CoachList,
    meta: {
      button: {
        text: ' + 白名单',
        path: 'add'
      }
    }
  },
  {
    name: '添加白名单',
    path: 'add',
    component: CoachEdit,
    meta: {
      activePath: '/main/whiteList/list'
    }
  },
  {
    name: '编辑白名单',
    path: 'edit',
    component: CoachEdit,
    meta: {
      activePath: '/main/whiteList/list'
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/whiteList/index.js